import React from 'react';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './OloCheckout.css';
import CheckoutBody from './components/CheckoutBody';

export default class OloCheckout extends React.Component {
  render() {
    const { trigger } = this.props;
    return (
      <Modal className="checkout-modal" trigger={trigger} dimmer="inverted">
        <Modal.Header>Checkout</Modal.Header>
        <Modal.Content>
          <CheckoutBody {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

OloCheckout.propTypes = {
  locationId: PropTypes.number.isRequired,
  cart: PropTypes.shape({
    id: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        selectedVariation: PropTypes.shape({
          id: PropTypes.number,
          menu_item: PropTypes.number,
          name: PropTypes.string,
          order: PropTypes.number,
          price: PropTypes.number,
        }),
        selectedModifiers: PropTypes.array,
        specialInstructions: PropTypes.string,
        quantity: PropTypes.number,
      }),
    ),
  }),
};
